import { useCallback, useEffect, useState } from 'react';
import { setPageLocked } from '../api';

// Per-page lock state. Starts from whatever the page resource itself says
// (tolerant of camel/kebab attribute casing, matching this codebase's usual
// pattern for newer v3 resources), and only flips in the UI once the PATCH
// actually succeeds — never optimistically.
export default function usePageLock({ firstBookId, currentPage }) {
  const pageId = currentPage?.id;
  const serverLocked = !!(currentPage?.attributes?.locked ?? currentPage?.locked);

  const [isLocked, setIsLocked] = useState(serverLocked);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Follow the server's value for whichever page is currently open.
  useEffect(() => {
    setIsLocked(serverLocked);
    setError(null);
  }, [pageId, serverLocked]);

  const toggleLock = useCallback(async () => {
    if (!pageId) return;
    const next = !isLocked;
    setIsLoading(true);
    setError(null);
    try {
      await setPageLocked(firstBookId, pageId, next);
      setIsLocked(next);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [firstBookId, pageId, isLocked]);

  return { isLocked, isLoading, error, toggleLock };
}
